import { StyleSheet } from "react-native";

export default StyleSheet.create({
  loading: {
    position: "absolute",
    zIndex: 9,
    width: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF55",
    justifyContent: "center"
  }
});
